import { render, staticRenderFns } from "./game-component.vue?vue&type=template&id=595faeb4&"
import script from "./game-component.vue?vue&type=script&lang=js&"
export * from "./game-component.vue?vue&type=script&lang=js&"
import style0 from "./game-component.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
